/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner } from './CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner';
import {
    CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerFromJSON,
    CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerFromJSONTyped,
    CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerToJSON,
    CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerToJSONTyped,
} from './CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner';

/**
 * 
 * @export
 * @interface CalculateWorkingTimeCostData
 */
export interface CalculateWorkingTimeCostData {
    /**
     * 
     * @type {number}
     * @memberof CalculateWorkingTimeCostData
     */
    employeeId: number;
    /**
     * 
     * @type {number}
     * @memberof CalculateWorkingTimeCostData
     */
    jobRoleId: number;
    /**
     * 
     * @type {Date}
     * @memberof CalculateWorkingTimeCostData
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof CalculateWorkingTimeCostData
     */
    endTime: Date;
    /**
     * An array of unpaid breaks during the period.
     * @type {Array<CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner>}
     * @memberof CalculateWorkingTimeCostData
     */
    unpaidWorkingPeriods?: Array<CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner>;
}

/**
 * Check if a given object implements the CalculateWorkingTimeCostData interface.
 */
export function instanceOfCalculateWorkingTimeCostData(value: object): value is CalculateWorkingTimeCostData {
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('jobRoleId' in value) || value['jobRoleId'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function CalculateWorkingTimeCostDataFromJSON(json: any): CalculateWorkingTimeCostData {
    return CalculateWorkingTimeCostDataFromJSONTyped(json, false);
}

export function CalculateWorkingTimeCostDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateWorkingTimeCostData {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
        'jobRoleId': json['jobRoleId'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'unpaidWorkingPeriods': json['unpaidWorkingPeriods'] == null ? undefined : ((json['unpaidWorkingPeriods'] as Array<any>).map(CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerFromJSON)),
    };
}

  export function CalculateWorkingTimeCostDataToJSON(json: any): CalculateWorkingTimeCostData {
      return CalculateWorkingTimeCostDataToJSONTyped(json, false);
  }

  export function CalculateWorkingTimeCostDataToJSONTyped(value?: CalculateWorkingTimeCostData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'jobRoleId': value['jobRoleId'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'unpaidWorkingPeriods': value['unpaidWorkingPeriods'] == null ? undefined : ((value['unpaidWorkingPeriods'] as Array<any>).map(CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerToJSON)),
    };
}

